import { Cargo } from 'src/app/base/domain/cargo.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class CargoSerializer extends DomainSerializer<Cargo> {}
